import { Add } from "@mui/icons-material";
import { Box, Button, Card, CardContent, TextField } from "@mui/material";
import { useEffect, useState } from "react";

export default function NewPollContainer({ meta, setMeta }) {
  const [options, setOptions] = useState(["", "", ""]);
  const [question, setQuestion] = useState("");

  useEffect(() => {
    setMeta({ ...meta, question, options });
  }, [question, options]);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 4,
          mt: 2,
        }}
      >
        <Card id="poll-container" style={{ borderRadius: "20px" }}>
          <CardContent>
            <TextField
              fullWidth
              label="Poll Question"
              value={question}
              autoComplete="off"
              variant="standard"
              color="secondary"
              style={{ marginBottom: "20px" }}
              onChange={(e) => setQuestion(e.target.value)}
            />

            {options.map((option, index) => (
              <TextField
                key={index}
                fullWidth
                size="small"
                label={`Option ${index + 1}`}
                value={option}
                style={{ margin: "10px 0" }}
                onChange={(e) => {
                  const newOptions = [...options];
                  newOptions[index] = e.target.value;
                  setOptions(newOptions);
                }}
              />
            ))}
            {options.length < 5 && (
              <Button
                variant="text"
                color="info"
                size="small"
                startIcon={<Add />}
                sx={{ mt: 2 }}
                onClick={() => {
                  setOptions([...options, ""]);
                }}
              >
                Add Option
              </Button>
            )}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
